import React, {useContext, useRef} from 'react';
import {graphql} from 'gatsby';
import Button from '../button/button';
import HubSpotContent from '../form/hubspotFormContent/hubspotFormContent';
import VirtualCityPopup from '../../virtualCity/popup/popup';
import Close from '../../images/CloseSymbolThin.inline.svg';

import {ModalContext} from '../../context/ModalContext';
import useRoveFocus from "../../lib/hooks/useRoveFocus";
import useOnClickOutside from "../../lib/hooks/useOnClickOutside";

/**
* Displays overlay and modal
* 
*/
const Modal = ({data}) => {
  const { modalData, toggleModal, modalClasses } = useContext(ModalContext);    
  const node = useRef();
  useRoveFocus(node, 9, 9);
  useOnClickOutside(node, () => toggleModal(null));

  return (
    <>
      {
        (modalData || data ) && 
        <div className={`modal__overlay ${modalClasses || 'default'}`}>
          <div className={`modal`} ref={node} role="dialog" aria-modal="true">
            {/* eslint-disable-next-line */}
            <Button autoFocus aria-label="Exit popup" onClick={()=>toggleModal(null)} className="modal__exit" icon={false}><Close/></Button>
           {
            ( modalData?.__typename === 'DatoCmsComponentFormCopy' || data?.__typename === 'DatoCmsComponentFormCopy' ) ?
            <HubSpotContent uniqueid={`modalOpen`} data={(modalData || data )}/>
            : 
            <VirtualCityPopup uniqueid={`modalOpen`} data={modalData} />
           }
          </div>
        </div>  
      }
    </>
  );

};

export default Modal;

export const ModalFragment = graphql`
fragment ModalFragment on DatoCmsComponentModal {
  content{
    ...HubspotContentFragment
  }
}`;


